(() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const initialize = (section) => {
    if (!section || section.dataset.vibroReady === 'true') return;

    section.dataset.vibroReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const stage = section.querySelector('[data-vibro-stage]');
    const visual = section.querySelector('.dorimo-vibro-showcase__visual');
    let ticking = false;

    const update = () => {
      ticking = false;

      if (reducedMotion.matches) {
        section.classList.remove('is-mobile-pinned', 'is-mobile-passed');
        section.style.setProperty('--vibro-progress', '1');
        section.style.setProperty('--vibro-reveal', '100%');
        section.style.setProperty('--vibro-scale', '1');
        section.classList.add('is-second-scene');
        return;
      }

      const rect = section.getBoundingClientRect();
      const isMobile = window.innerWidth <= 749;
      let progress;

      if (isMobile && stage && visual) {
        const stageRect = stage.getBoundingClientRect();
        const visualHeight = visual.offsetHeight;
        const headerHeight =
          Number.parseFloat(
            window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
          ) || 0;
        const stickyTop = headerHeight + 8;
        const scrollDistance = Math.max(stage.offsetHeight - visual.offsetHeight, 1);
        progress = clamp((stickyTop - stageRect.top) / scrollDistance, 0, 1);

        section.style.setProperty('--vibro-mobile-visual-height', `${visualHeight}px`);
        section.style.setProperty('--vibro-mobile-pin-top', `${stickyTop}px`);
        section.style.setProperty('--vibro-mobile-pin-left', `${stageRect.left}px`);
        section.style.setProperty('--vibro-mobile-pin-width', `${stageRect.width}px`);

        const isPast = stageRect.bottom <= stickyTop + visualHeight;
        const isPinned = stageRect.top <= stickyTop && !isPast;
        section.classList.toggle('is-mobile-pinned', isPinned);
        section.classList.toggle('is-mobile-passed', isPast);
      } else {
        section.classList.remove('is-mobile-pinned', 'is-mobile-passed');
        const scrollDistance = Math.max(section.offsetHeight - window.innerHeight, 1);
        progress = clamp(-rect.top / scrollDistance, 0, 1);
      }

      const revealProgress = isMobile ? progress : clamp(progress / .68, 0, 1);

      section.style.setProperty('--vibro-progress', revealProgress.toFixed(3));
      section.style.setProperty('--vibro-reveal', `${(revealProgress * 100).toFixed(2)}%`);
      section.style.setProperty('--vibro-scale', (1 + revealProgress * .025).toFixed(4));
      section.classList.toggle('is-second-scene', revealProgress >= .52);
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    reducedMotion.addEventListener('change', requestUpdate);
    update();
  };

  document.querySelectorAll('[data-vibro-showcase]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(
      event.target.matches('[data-vibro-showcase]')
        ? event.target
        : event.target.querySelector('[data-vibro-showcase]')
    );
  });
})();
